export const forecastGeneralHistoryStoreSlice = (set) => ({
	fgSelectedOwner: 0,
	fgSelectedYear: new Date().getFullYear(),
	fgSearch: '',
	fgPaginationModel: {
		pageSize: 25,
		page: 0,
	},
	fgSelectedMarketplace: 1,

	setFgSelectedOwner: (selectedOwner) =>
		set(() => ({ fgSelectedOwner: selectedOwner })),
	resetFgSelectedOwner: () => set(() => ({ fgSelectedOwner: 0 })),
	setFgSelectedYear: (selectedYear) =>
		set(() => ({ fgSelectedYear: selectedYear })),
	setFgSearch: (search) => set(() => ({ fgSearch: search })),
	setFgPaginationModel: (paginationModel) =>
		set(() => ({ fgPaginationModel: paginationModel })),
	setFgSelectedMarketplace: (selectedMarketplace) =>
		set(() => ({ fgSelectedMarketplace: selectedMarketplace })),
	resetFgSelectedMarketplace: () => set(() => ({ fgSelectedMarketplace: 1 })),
});
